import { useSyncExternalStore } from 'react';

import {
    getIsLive,
    subscribeIsLive,
} from 'src/services/websocket/live-updates-signal';

export function useIsLive(): boolean {
    return useSyncExternalStore(subscribeIsLive, getIsLive);
}
